import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function DirectionsIcon(props: IconProps) {
    return <Icon {...props} iconKey={"directions"}/>
}
